import React, { type ReactNode } from "react";
import { styled, Box, Typography, type BoxProps, type TypographyProps } from "@mui/material";

import { isFormattedMessageElement } from "../../../utils/react-intl";

interface ModalSubTitleProps extends TypographyProps {
	children: ReactNode;
}

export const ModalSubTitle: React.FC<ModalSubTitleProps> = styled((props) => (
	<Typography variant="subtitle1" {...props} />
))({});

const StyledModalSubTitleContainer: React.FC<BoxProps> = styled(Box)({
	gridArea: "subtitle",
});

interface ModalSubTitleContainerProps extends BoxProps {
	readonly children: ReactNode;
}

export const ModalSubTitleContainer: React.FC<ModalSubTitleContainerProps> = ({ children, ...props }) => {
	if (children === null || children === undefined || children === false) {
		return null;
	}

	const isText = typeof children === "string" || isFormattedMessageElement(children);

	return (
		<StyledModalSubTitleContainer {...props}>
			{isText === true && <ModalSubTitle>{children}</ModalSubTitle>}
			{isText === false && children}
		</StyledModalSubTitleContainer>
	);
};
